import React, { useCallback, useMemo } from 'react';
import { faOnTilesFilterApply, faOnTilesFilterRemove } from '../analytics-services';

const OptionTile = ({
  filterOption,
  filterStats,
  appliedValues,
  handleOptionClick,
  filterUrlParam,
}) => {
  const count = useMemo(() => {
    const currentFilterStats = filterStats?.find(
      stat => stat.filterValue === filterOption.uniqueId
    );

    return currentFilterStats?.packageCount;
  }, [filterOption, filterStats]);

  const isApplied = useMemo(
    () =>
      appliedValues?.indexOf(filterOption?.uniqueId) > -1 ||
      appliedValues?.indexOf(filterOption?.uniqueId?.toLowerCase?.()) > -1,
    [appliedValues, filterOption?.uniqueId]
  );

  const handleApplyFilter = useCallback(() => {
    if (isApplied) {
      faOnTilesFilterRemove(filterUrlParam, filterOption?.uniqueId);
      handleOptionClick([], { prop54: `filter_remove_ui_<urlParam>_${filterOption?.uniqueId}` });
    } else {
      faOnTilesFilterApply(filterUrlParam, filterOption?.uniqueId);
      handleOptionClick([filterOption?.uniqueId], {
        prop54: `filter_apply_ui_<urlParam>_${filterOption?.uniqueId}`,
      });
    }
  }, [isApplied, filterOption?.uniqueId, appliedValues]);

  return (
    <span
      className={`offer ${isApplied ? 'active' : ''} ${count > 0 ? '' : 'disabled'}`}
      onClick={handleApplyFilter}
    >
      <span>
        {filterOption.filterText} {count >= 0 && `(${count})`}
      </span>
    </span>
  );
};

export default OptionTile;
